var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelgrayicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7616 10L19.6326 2.14152C19.8678 1.90626 20 1.58718 20 1.25447C20 0.921766 19.8678 0.602686 19.6326 0.367427C19.3973 0.132167 19.0782 0 18.7455 0C18.4128 0 18.0937 0.132167 17.8585 0.367427L10 8.2384L2.14152 0.367427C1.90626 0.132167 1.58718 2.95392e-07 1.25447 2.97871e-07C0.921766 3.0035e-07 0.602686 0.132167 0.367427 0.367427C0.132167 0.602686 3.0035e-07 0.921766 2.97871e-07 1.25447C2.95392e-07 1.58718 0.132167 1.90626 0.367427 2.14152L8.2384 10L0.367427 17.8585C0.132167 18.0937 0 18.4128 0 18.7455C0 19.0782 0.132167 19.3973 0.367427 19.6326C0.602686 19.8678 0.921766 20 1.25447 20C1.58718 20 1.90626 19.8678 2.14152 19.6326L10 11.7616L17.8585 19.6326C18.0937 19.8678 18.4128 20 18.7455 20C19.0782 20 19.3973 19.8678 19.6326 19.6326C19.8678 19.3973 20 19.0782 20 18.7455C20 18.4128 19.8678 18.0937 19.6326 17.8585L11.7616 10Z",
    fill: "#686868"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelgrayicon);
export default __webpack_public_path__ + "static/media/cancelgrayicon.45736403cf7e4170eb71719ad1910d42.svg";
export { ForwardRef as ReactComponent };